/**
 * 运营后台 - 合作监控（全局视角，只读）
 * 调 GET /admin/partnerships（后端已就绪）
 * 运营不操作合作，只看全局签约情况
 */

import { Card, Table, Badge, useApi, formatScope } from '../../components/ui'
import { api } from '../../api/client'
import { HelpBubble } from '../../components/HelpBubble'

interface Partnership {
  partnership_id: string
  seller_id: string
  factory_id: string
  commission_rate: string
  product_scope: unknown
  valid_from: string
  valid_to: string
  status: string
  signed_at: string | null
}

export function AdminPartnerships() {
  const list = useApi<Partnership[]>(async () => api.get('/admin/partnerships'), [])

  return (
    <div>
      <h2 style={{ marginTop: 0 }}>合作监控</h2>
      <Card title={`全局合作关系（${list.data?.length ?? 0}）`}>
        <Table<Partnership>
          rows={list.data ?? []}
          empty={list.loading ? '加载中...' : '暂无合作（商家在「代销合作」发起邀约、工厂接受后会出现在这里）'}
          columns={[
            { key: 'partnership_id', title: '合作ID' },
            { key: 'seller_id', title: '商家' },
            { key: 'factory_id', title: '工厂' },
            {
              key: 'commission_rate',
              title: '佣金率',
              render: (r) => `${(Number(r.commission_rate) * 100).toFixed(1)}%`,
            },
            { key: 'product_scope', title: '范围', render: (r) => formatScope(r.product_scope) },
            { key: 'signed_at', title: '签约时间', render: (r) => (r.signed_at ? r.signed_at.slice(0, 10) : '-') },
            { key: 'valid', title: '有效期', render: (r) => `${r.valid_from?.slice(0, 10) ?? '-'} ~ ${r.valid_to?.slice(0, 10) ?? '-'}` },
            { key: 'status', title: '状态', render: (r) => <Badge status={r.status} /> },
          ]}
        />
        <div style={{ marginTop: 8, color: '#888', fontSize: 12 }}>
          运营只读监控合作签约情况，不操作合作。佣金率=商家服务费占比（商家开服务费票的基数）。
        </div>
      </Card>
      <HelpBubble pageKey="admin-partnerships" title="合作监控">
        <p>运营<b>只读</b>监控全局合作关系（商家×工厂多对多），不操作合作。</p>
        <p>佣金率=商家服务费占比。合作 ACTIVE 状态才能下单分账。</p>
      </HelpBubble>
    </div>
  )
}
